function initDropdownMenu() {
  const menuSelector = '.js-dropdown-menu';
  const btnSelector = '.js-dropdown-menu-btn';
  const btnCloseSelector = '.js-dropdown-menu-btn-close';

  const menuList = document.querySelectorAll(menuSelector);

  if (!menuList.length) return;

  for (let i = 0; i < menuList.length; i++) {
    const menu = menuList[i];
    const btn = menu.querySelector(btnSelector);
    const btnClose = menu.querySelector(btnCloseSelector);

    btn.addEventListener('click', (e) => {
      e.preventDefault();

      if (menu.getAttribute('data-state') === 'close') {
        menu.setAttribute('data-state', 'open')
      } else {
        menu.setAttribute('data-state', 'close')
      }
    });

    btnClose.addEventListener('click', (e) => {
      e.preventDefault();

      btn.dispatchEvent(new Event('click'));
    });
  }

  document.addEventListener('click', (e) => {
    const curMenu = e.target.closest(menuSelector);

    if (curMenu) return;

    for (let i = 0; i < menuList.length; i++) {
      const menu = menuList[i];

      if (menu.getAttribute('data-state') !== 'open') continue;

      const btn = menu.querySelector(btnSelector);

      btn.dispatchEvent(new Event('click'));
    }
  });
}

export {initDropdownMenu};
